// extracted by mini-css-extract-plugin
export default {"video-player":"VideoInstitucional_video-player__m0TJX"};